import {infiniteQueryOptions, keepPreviousData} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {AssistantDependencies} from '../dependencies';
import {keys} from './keys';

export type ListConversationsQueryDependencies = Pick<AssistantDependencies, 'controllers'>;

export const listConversationsQuery = ({controllers}: ListConversationsQueryDependencies) =>
  infiniteQueryOptions({
    queryKey: keys.listAll(),
    queryFn: ({pageParam}) =>
      controllers.assistantController.list({cursor: pageParam}).then(unwrap),
    initialPageParam: null as string | null,
    getNextPageParam: lastPage => lastPage.nextCursor ?? undefined,
    placeholderData: keepPreviousData,
  });
